export class ArrayHelper {
	static move(array: any, fromIndex: number, toIndex: number) {
		let element = array[fromIndex];
		array.splice(fromIndex, 1);
		array.splice(toIndex, 0, element);
	}

	static insert(array: any, item: any, toIndex: number) {
		array.splice(toIndex, 0, item);
	}
}
